import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-structures',
  templateUrl: './fees-structures.component.html',
  styleUrls: ['./fees-structures.component.scss']
})
export class FeesStructuresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
